import React from "react"

import { ChildSelector } from "../helpers/ChildSelector"

import * as twoColumnTextSectionStyles from "../styles/TwoColumnTextSection.module.css"

export default function TwoColumnTextSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `two-column-text-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const titleRight = ChildSelector.select(
    content,
    `two-column-text-section-title-right`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "two-column-text-section-content")
    .map(t => t.text)

  const textStackLetf = content.childNodes
    .filter(node => node.classNames === "two-column-text-section-content-left")
    .map(t => t.text)

  return (
    <div className={`${props.className} ${twoColumnTextSectionStyles.wrapper}`}>
      <div className={`row ${twoColumnTextSectionStyles.wrapperFeature}`}>
        <div className={`col-6 ${twoColumnTextSectionStyles.feature}`}>
          <h2
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStackLetf.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
        <div className={`col-6 ${twoColumnTextSectionStyles.feature}`}>
          <h2
            dangerouslySetInnerHTML={{
              __html: titleRight,
            }}
          />
      
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
      </div>
    </div>
  )
}
